import { useRuntimeConfig } from '#app';

const getAuthToken = () => {
    if (!import.meta.client) return null;
    return localStorage.getItem('token');
}

export const useBackendApiPost = async <T>(endpoint: string, body: any): Promise<T> => {
    const config = useRuntimeConfig();
    const authToken = getAuthToken();

    const headers: HeadersInit = {
        'Content-Type': 'application/json',
        'x-api-key': 'N9tUwtDb3bEICdqmx1Fyp'
    };

    if (authToken) {
        headers['Authorization'] = `Bearer ${authToken}`;
    }

    try {
        const response = await $fetch<T>(`${config.public.API_BASE_URL}${endpoint}`, {
            method: 'POST',
            headers,
            body,
        });
        return response;
    } catch (error) {
        console.error('Fehler bei der POST-Anfrage:', error);
        throw error;
    }
};

export const useBackendApiGet = async <T>(endpoint: string, options: RequestInit = {}): Promise<T> => {
    const config = useRuntimeConfig();
    const authToken = getAuthToken();

    const headers: HeadersInit = {
        'Content-Type': 'application/json',
        'x-api-key': 'N9tUwtDb3bEICdqmx1Fyp'
    }

    if (authToken) {
        headers['Authorization'] = `Bearer ${authToken}`;
    }

    try {
        const response = await $fetch<T>(`${config.public.API_BASE_URL}${endpoint}`, {
            ...options,
            method: 'GET',
            headers
        });

        return response;
    } catch (error) {
        console.error('Fehler beim Abrufen der Daten:', error);
        throw error;
    }
};
